// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"a6a51b65","818":"3b53517f","1476":"1c739222","6662":"3b53517f"}[chunkId] + ".chunk.css";
};